import PaymentBankSlip from "../../../models/payment-back-slip.entity";
import PaymentCreditCard from "../../../models/payment-credit-card.entity";
import http from "../../../services/http.service";

class PaymentService {
  public sendCreditCard = async (payment: PaymentCreditCard) => {
    return http.post('v1/payment/credit-card', new PaymentCreditCard().stateToFormatPayload(payment))
      .catch((error) => {
        const { data } = error.response;
        return Promise.reject(data.errors);
      });
  }

  public sendBankSlip = async (payment: PaymentBankSlip) => {
    return http.post('v1/payment/bank-slip', payment.formatPayload())
      .catch((error) => {
        const { data } = error.response;
        return Promise.reject(data.errors);
      });
  }
}

export default new PaymentService();
